import { Grid, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import { InfoBox } from "../designUi";

import { getUrlPathId } from "../../utils/url-id";
import { useLocation } from "react-router-dom";
import { useNotificationService } from "../notification";
import { MedicStatsDummy } from "../../interface/medic";
import { useQuery } from "@tanstack/react-query";
import { apiGetMedicStats } from "../../api/medic";
import { MedicBoxIcon } from "../UIElements/svg-icons";

const MedicStats = () => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");
  const location = useLocation();
  const { showNotification } = useNotificationService();
  const medicId = getUrlPathId(location?.pathname);

  // Get medic stats using useQuery
  const {
    data: stats,
    error,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["medicStats", medicId], // unique key for caching
    queryFn: () => apiGetMedicStats({ medicId }),
    select: (data) => {
      console.log(data);
      if (data.status === 200) {
        return data?.data?.data;
      } else return MedicStatsDummy;
      // return data?.data ?? MedicStatsDummy;
    },
    enabled: !!medicId, // ensure both are available before fetching
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  if (error) {
    showNotification("Fetch process failed", "error");
  }

  return (
    <>
      <Grid container sx={{ padding: 2 }}>
        <Grid
          item
          xs={isSmall ? 12 : isMedium ? 6 : 4}
          sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
        >
          <InfoBox
            title={"Total Employment"}
            value={stats?.totalEmployment || 0}
            icon={<MedicBoxIcon />}
          />
        </Grid>{" "}
        <Grid
          item
          xs={isSmall ? 12 : isMedium ? 6 : 4}
          sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
        >
          <InfoBox
            title={"Total Application"}
            value={stats?.totalApplications || 0}
            icon={<MedicBoxIcon />}
          />
        </Grid>{" "}
        <Grid
          item
          xs={isSmall ? 12 : isMedium ? 6 : 4}
          sx={{ paddingX: isSmall ? 0 : 2, paddingY: 2 }}
        >
          <InfoBox
            title={"Total Shift"}
            value={stats?.totalShifts || 0}
            icon={<MedicBoxIcon />}
          />
        </Grid>
      </Grid>
      <Stack
        direction="row"
        spacing={5}
        sx={{
          my: 2,
          mx: 3,
          backgroundColor: "white",
          p: 3,
        }}
      >
        <Stack>
          <Typography
            variant="subtitle2"
            sx={{
              fontFamily: "Inter",
              fontWeight: "700",
              color: theme.palette.neutral.light,
              my: 1,
            }}
          >
            Total Completed Shift
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              fontFamily: "Inter",
              color: theme.palette.neutral.main,
              my: 1,
            }}
          >
            {stats?.totalCompletedShift || 0}
          </Typography>
        </Stack>
        <Stack>
          <Typography
            variant="subtitle2"
            sx={{
              fontFamily: "Inter",
              fontWeight: "700",
              color: theme.palette.neutral.light,
              my: 1,
            }}
          >
            Total Absent
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              fontFamily: "Inter",
              color: theme.palette.neutral.main,
              my: 1,
            }}
          >
            {stats?.totalAbsent || 0}
          </Typography>
        </Stack>
      </Stack>
    </>
  );
};

export default MedicStats;
